import React, { useEffect, useState } from 'react';
import { ChipsTagsView } from 'whealth-core-web/components';

function LeadSourceFilter(props) {
  const { filterData, setFilterData } = props;
  const [activeData, setActiveData] = useState([]);
  const [activeSubData, setActiveSubData] = useState([]);

  const leadSource = {
    digital: 'Digital',
    dro: 'DRO',
    organic: 'Organic',
    social: 'Social',
    offline_brand_marketing: 'Offline/Brand Marketing',
  };

  const subSourceMap = {
    digital: ['Google', 'Facebook', 'Practo', 'Just Dial', 'Unattributed', 'Database'],
    dro: ['Private Clinic', 'CGHS', 'DJB', 'ECHS', 'DU', 'BSES', 'Chemist', 'Sports'],
    organic: [
      'Website',
      'Practo',
      'Just Dial',
      'Blogs',
      'Referred By Patient',
      'Referred By Nivaan Doctor',
      'Referred by Partner Hospital',
      'Referred by Nivaan Team',
      'Referred By Other Doctor',
      'Others',
      'BrizaBot',
      'RonicBot',
    ],
    social: ['Facebook', 'YouTube', 'Instagram'],
    offline_brand_marketing: ['Newspaper', 'Signboard', 'Billboard', 'Camp'],
  };

  // Sub sources of all selected sources, de-duplicated (e.g. Practo belongs to Digital and Organic)
  const availableSubSources = [...new Set(activeData.flatMap((key) => subSourceMap[key] || []))];

  useEffect(() => {
    let stringActiveData = activeData.map((item) => {
      return leadSource[item];
    });
    stringActiveData = stringActiveData?.toString();
    // Drop sub sources whose source is no longer selected
    let stringSubData = activeSubData.filter((item) => availableSubSources.includes(item)).toString();
    let obj = { source: stringActiveData, sub_source: stringSubData };
    setFilterData(obj);
  }, [activeData, activeSubData]);

  useEffect(() => {
    setActiveData(new Array());
    setActiveSubData(new Array());
  }, []);

  useEffect(() => {
    const tempActiveData = filterData?.source?.split(',');
    setActiveData(
      tempActiveData?.map((item) => {
        return Object.keys(leadSource).find((key) => leadSource[key] === item);
      }) || []
    );
    setActiveSubData(filterData?.sub_source?.split(',').filter(Boolean) || []);
  }, [filterData]);

  const renderHeading = () => {
    return <div className='filterHeadings mt-3'>Lead Source</div>;
  };

  const renderChips = () => {
    return (
      <div>
        <div className='mt-3' />
        <ChipsTagsView
          setActiveTags={setActiveData}
          activeTags={activeData}
          data={Object.keys(leadSource).map((item) => {
            return {
              id: item,
              title: leadSource[item],
            };
          })}
        />
      </div>
    );
  };

  const renderSubSourceChips = () => {
    if (!availableSubSources.length) return null;
    return (
      <div>
        <div className='filterHeadings mt-3'>Sub Source</div>
        <div className='mt-3' />
        <ChipsTagsView
          setActiveTags={setActiveSubData}
          activeTags={activeSubData}
          data={availableSubSources.map((item) => {
            return {
              id: item,
              title: item,
            };
          })}
        />
      </div>
    );
  };

  return (
    <div>
      {renderHeading()}
      {renderChips()}
      {renderSubSourceChips()}
    </div>
  );
}

export default LeadSourceFilter;
